import {FILTER_KEY_ALL, getSpecificAsset} from "../../ducks/assets-duck.js";
import CloseIcon from "mdi-react/CloseIcon.js";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import dayjs from "dayjs";
import Button from "../util/Button.jsx";
import AddIcon from "mdi-react/AddIcon.js";
import {closePopup} from "../../ducks/popup-duck.js";
import {useAnnotations} from "../../api/use-annotations-api.js";

export default ({filterId: filterIdProp, assetId: assetIdProp, annotation}) => {

    const dispatch = useDispatch()
    const {postAnnotation, updateAnnotation} = useAnnotations()

    const isEditing = !!annotation

    const [filterId, setFilterId] = useState(annotation ? (annotation.category_id || FILTER_KEY_ALL) : filterIdProp)
    const [assetId, setAssetId] = useState(annotation ? annotation.asset_id : assetIdProp)
    const {name} = useSelector(state => getSpecificAsset(state, parseInt(assetId)))

    const [isPosting, setIsPosting] = useState(false)
    const [dateInput, setInputDate] = useState(annotation ? dayjs(annotation.date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"))
    const [textInput, setTextInput] = useState(annotation ? annotation.text : '')

    const isFilterSet = filterId !== FILTER_KEY_ALL

    const onClickSubmit = async () => {
        setIsPosting(true)
        const body = {
            assetId,
            filterId,
            date: dateInput,
            text: textInput,
        }
        if(isEditing){
            await updateAnnotation({...body, annotationId: annotation.id})
        } else {
            await postAnnotation(body)
        }
        dispatch(closePopup())
    }

    return (
        <div>
            <h2>
                {isEditing ? 'Edit annotation' : 'New annotation'}
            </h2>
            <div className='filters flex-vertical-center'>
                {filterId && isFilterSet && !assetId &&
                <button
                   className='filter-button flex-vertical-center category'
                   onClick={()=>setFilterId(FILTER_KEY_ALL)}
                >
                    {filterId} <CloseIcon/>
                </button>
                }
                {assetId &&
                <button
                    className='filter-button flex-vertical-center'
                    onClick={()=>setAssetId()}
                >
                    {name} <CloseIcon/>
                </button>
                }
            </div>
            <br />
            <div className='flex-vertical-center'>
                <input
                    type='date'
                    value={dateInput}
                    onChange={e => setInputDate(e.target.value)}
                />
                <input
                    type='text'
                    value={textInput}
                    placeholder={'annotation text'}
                    onChange={e => setTextInput(e.target.value)}
                />
            </div>
            <br />
            <div className='input-div'>
                <Button
                    onClick={onClickSubmit}
                    disabled={isPosting || !textInput}
                    icon={<AddIcon/>}
                >
                    {isEditing ? 'Save' : 'Add annotation'}
                </Button>
            </div>
        </div>
    )
}